import "../slider/_slider-solution.js";
import "../components/_select-custom.js";
import $ from "jquery";

jQuery(document).ready(function(){
    jQuery(document).bind('gform_confirmation_loaded', function(){
        $('.w-form').find('.desc').hide();
    });
});



// WEBPACK FOOTER //
// ./resources/scripts/pages/form-page.js